import styles from "./SelContent1.module.css";
import RegistrationPopup from "./RegistrationPopup";

import {
  Link,
} from "react-router-dom";
const SelContent1 = () => {
  return (
    <div className={styles.divParent}>
          <img className={styles.heroIcon} alt="" src="/selimg.svg" />
      <div className={styles.div}>

        <b className={styles.noChildWillContainer}>
          <span>{`Strong minds, strong schools: building resilience through mental health support`}</span>
        </b>

        <div className={styles.genxtureBringsTheContainer}>

          <span>{`A Socio emotional learning programs that shapes children's developing neural circuitry & executive functions, by encouraging optimal brain development and social connection through a supportive environment.`}</span>

        </div>

        <div className style={{width:'100%'}}>
          <div className><RegistrationPopup text="Start Learning" style1={styles.a} style2={styles.startLearning}/></div>
        </div>

        <div style={{display: 'none' /*App*/}} className={styles.div1}>

          <b className={styles.downloadApp}>Download App:</b>
          <div className={styles.playStoresvgParent}>
            <Link style={{textDecoration: 'none', color: 'white'}} to="https://play.google.com/store/apps/details?id=com.genexture"><img
              className={styles.playStoresvgIcon}
              alt=""
              src="/play-storesvg.svg"
            /></Link>
            <img
              className={styles.appStoresvgIcon}
              alt=""
              src="/app-storesvg.svg"
            />
          </div>
        </div>

      </div>


    </div>
  );
};

export default SelContent1;
